import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { getColor } from 'common/constants/_colors';
import React from 'react';
import styled from 'styled-components';

const StyledErrorContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 0.5rem;
`;

const InfoBox = ({
  mt = 'medium',
  mb,
  icon = 'infoOutlined',
  iconAlign = 'start',
  iconSize = 'small',
  iconColor = 'nepal',
  children,
  contentDirection = 'column',
  backgroundColor = 'zircon',
  borderColor = 'fog',
  backgroundAlpha = null,
  borderAlpha = null,
  padding = 'small',
  position = null,
  width
}) => (
  <Flex
    padding={padding}
    position={position}
    mt={mt}
    mb={mb}
    items={iconAlign}
    style={{
      backgroundColor: getColor(backgroundColor, backgroundAlpha),
      border: `1px solid ${getColor(borderColor, borderAlpha)}`,
      borderRadius: '4px'
    }}
    {...(width && { width })}
  >
    <Flex>
      <Icon name={icon} color={iconColor} size={iconSize} />
    </Flex>
    <Flex direction={contentDirection} pl='x-small'>
      {children}
    </Flex>
  </Flex>
);

export const ErrorBox = ({ children }) => (
  <InfoBox
    mt={null}
    icon='erroroutline'
    iconAlign='center'
    iconColor='torchRed'
    backgroundColor='torchRed'
    backgroundAlpha={0.1}
    borderColor='torchRed'
    borderAlpha={0.2}
    width='fit-content'
  >
    <StyledErrorContentWrapper>{children}</StyledErrorContentWrapper>
  </InfoBox>
);

export default InfoBox;
